module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Q03D"))).then(() => parcelRequire('37nVf'));